var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVictory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 762.98,
    height: 782.45,
    viewBox: "0 0 762.98 782.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #eae8f2;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: #3558a1;\n      }\n\n      .cls-8 {\n        fill: #20418a;\n      }\n\n      .cls-9 {\n        fill: #486cb8;\n      }\n\n      .cls-10 {\n        fill: #f2a72e;\n      }\n\n      .cls-11 {\n        fill: #ed5353;\n      }\n\n      .cls-12 {\n        fill: #596fff;\n      }\n\n      .cls-13 {\n        fill: #8288d4;\n        opacity: 0.21;\n      }\n\n      .cls-13, .cls-34, .cls-40 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-14 {\n        fill: #27427a;\n      }\n\n      .cls-15 {\n        fill: #ffc2b0;\n      }\n\n      .cls-16 {\n        fill: #cedaed;\n      }\n\n      .cls-17 {\n        fill: #223a6b;\n      }\n\n      .cls-18 {\n        fill: #4e62e0;\n      }\n\n      .cls-19 {\n        fill: #ffb73d;\n      }\n\n      .cls-20 {\n        fill: #ffcc75;\n      }\n\n      .cls-21 {\n        fill: #fff;\n      }\n\n      .cls-22 {\n        fill: #c5c5e0;\n      }\n\n      .cls-23 {\n        fill: #acacd1;\n      }\n\n      .cls-24 {\n        fill: #ba4141;\n      }\n\n      .cls-25 {\n        fill: #4a67a3;\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-29 {\n        fill: #eb9100;\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-32 {\n        fill: #f19729;\n      }\n\n      .cls-33, .cls-40 {\n        fill: #d9730d;\n      }\n\n      .cls-34 {\n        opacity: 0.09;\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-36 {\n        fill: #5768fa;\n      }\n\n      .cls-37 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-39 {\n        fill: #fab237;\n      }\n\n      .cls-40 {\n        opacity: 0.3;\n      }\n\n      .cls-41 {\n        fill: #e64c4c;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 121.64,
    y1: 122.56,
    x2: 355.6,
    y2: 253.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#eae8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 493.73,
    y1: 255.06,
    x2: 720.67,
    y2: 180.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eae8f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 437.22,
    y1: 285.09,
    x2: 596.04,
    y2: 405.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eae8f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 351.28,
    y1: 276.09,
    x2: 173.21,
    y2: 422.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eae8f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 323.81,
    y1: 482.04,
    x2: 490.79,
    y2: 482.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffbc4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fab34b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#eb953d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#de7c31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -145.93,
    y1: 460.51,
    x2: -248.85,
    y2: 304.59,
    gradientTransform: "matrix(1, 0, 0, -0.73, 595.75, 685.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#e5983e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#db8a37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ce782f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c9712c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 219.92,
    y1: 270.22,
    x2: 315.12,
    y2: 235.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffbc4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f3aa47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#df8c39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d37a31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cf732e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 486.02,
    y1: 250.24,
    x2: 587.39,
    y2: 250.24,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 407.33,
    y1: 253.45,
    x2: 405.55,
    y2: 47.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffbc4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fab34b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#eb953d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e18334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#de7c31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 482.74,
    y1: 840.79,
    x2: 480.43,
    y2: 748.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4e62e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4354bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 356.82,
    y1: 844.05,
    x2: 356.46,
    y2: 751.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 247,
    height: 213,
    xlinkHref: "data:image/png;base64,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"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.88,495C182.67,500.83,63,375.64,58.66,216.3c-1.5-54.86,11-107.91,48.84-149.35C241.9-80.36,351.63,147.8,454,78.38S666.83-47.15,737.3,135.13,672.85,530.9,532.71,504.38C471.63,492.82,392.6,492.12,322.88,495Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "94.68 173.56 341.35 270.45 362.56 248.26 149.72 72.2 94.68 173.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "714.48 130.06 496.58 228.67 497.52 254.08 735.46 228.12 714.48 130.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "643.1 385.94 471.03 299.62 443.6 325.41 569.18 441.09 643.1 385.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "128.68 385.08 331.55 305.3 358.97 331.09 237.69 442.8 128.68 385.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M639.79,624.7l-69.33,64.66L381.8,464.88l279.69-10L675.55,494C692,541.08,682.47,585.8,639.79,624.7Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "570.46 630.31 255.32 630.31 270.16 477.26 554.38 477.26 570.46 630.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 255.32,
    y: 630.5,
    width: 315.14,
    height: 54.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "526.5 533.55 291.51 533.55 302.58 419.43 514.51 419.43 526.5 533.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M490.81,450.69c0,10-7.69,19.22-20.4,26.25,0,0-59.8-7.85-74.46-17.82-28.89-19.65-19.23-48.51,11.36-48.51C453.43,410.61,490.81,428.56,490.81,450.69Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M123.29,646.29h0a5.3,5.3,0,0,0,7.31-1.56l2.07-3.19a5.3,5.3,0,0,0-1.56-7.32h0a5.31,5.31,0,0,0-7.31,1.56l-2.07,3.2A5.3,5.3,0,0,0,123.29,646.29Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "133.86 632.52 143.41 607.06 163.09 581.04 158.94 557.2 136.74 591.26 124.4 628.19 133.86 632.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M207.28,759.23c-12.62-4.48-34-4.26-47.66.48-6.62,2.29-10.24,5.22-10.79,8.14-.57-.24-1.18-.47-1.88-.69-7-2.15-17.68-1.89-23.94.58s-5.7,6.2,1.27,8.34,17.68,1.89,23.94-.57a9.61,9.61,0,0,0,3.49-2.12,22.54,22.54,0,0,0,6,3c12.62,4.48,34,4.26,47.66-.48S219.9,763.71,207.28,759.23Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M138.49,749.76c-.54,5.48-7.66.5-7.73-3.66,8.28-28.32,17.25-51.32,28-60.92l1.62-59.87,33.22-10-15.08,78.12Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M193.26,760.92l8,2.63c6.12.1,9.29-.49,10.92,1.87l.46.67c1.63,2.36.49,3.62-3,4.78l-15.89,3.88c-4.64,1.11-5.86-.4-7.06-3.2,0,0-.79-3.5,2.33-7.79C190.75,761.32,190.62,761.13,193.26,760.92Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M198.26,764.54c-1.67,4.45-9.33,3.61-9.26,0-9-55.53-3.56-59-4-71.13-.46-13.56-3.34-28.16-13.4-53.72l8.68,1.24a28.59,28.59,0,0,1,24.55,27.59C205.75,703.08,204.55,730.46,198.26,764.54Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M200.88,617.56l6.4,72.83s-25.4,22.53-57.56-4.39c6.77-10,7.42-22.7,6.24-36.14-3-12.6,0-23.05,3.46-32.2Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M188,547.43c-.51,7.9-5.59,11.19-11.33,7.35s-10-13.35-9.46-21.25,5.59-11.19,11.33-7.36S188.51,539.52,188,547.43Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195.69,543.35c-.52,7.9-7.91,12.33-13.65,8.49s-10-13.35-9.46-21.25,5.59-11.19,11.33-7.36S196.2,535.45,195.69,543.35Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M178.65,569.13l-.86-.18a5.39,5.39,0,0,1-4.19-6.35L177,546.27a5.39,5.39,0,0,1,6.35-4.19l.85.18a5.39,5.39,0,0,1,4.19,6.35l-.92,16.17C186.84,567.67,181.54,569.72,178.65,569.13Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M171.52,549.73s.2,5.35,9.31,3.89c7.28-1.16,2.31-13.72,9.2-16.44,7.57-3,6.89-13,3-16s-13-3.12-18.64,1S156,531.14,171.52,549.73Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M190.93,541.21a3.48,3.48,0,1,1-3.25-3.7A3.47,3.47,0,0,1,190.93,541.21Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M159.42,617.66c-.22-12.81.16-15.54-2.3-30-.82-4.87-.49-6.33-1.06-11.23-1-8.63,2.57-24.4,16.88-20.55l1.3.88a29.87,29.87,0,0,1,6.1,2.22c21,10.38,26.79,7.92,23.8,21.18-.72,9.91-6.7,16.48-3.26,37.45C196.85,631.75,164.33,627.68,159.42,617.66Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M188.32,553l-1.22-1.69a5.21,5.21,0,0,0,4.41.18A6.75,6.75,0,0,1,188.32,553Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M174.08,554.66a2.49,2.49,0,0,0-3,2.9c.36,1.93,1.59,4.23,5.15,5.37,4.93,1.58,10.3.6,12.88-.06a.71.71,0,0,0,.18-1.3C186.37,559.82,179.29,555.83,174.08,554.66Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M138.45,750.23l-1.66,8.31c.64,6.14,1.62,9.23-.55,11.15l-.61.54c-2.16,1.92-4.48.81-5.15-2.46l-5.39-14.83a7.21,7.21,0,0,1,3.74-7.68s2.32-1.39,6.26,1C137.69,747.88,137.92,747.62,138.45,750.23Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.75,767.56l10.15-.76a1.2,1.2,0,0,0,.38-2.28l-6.42-3.68Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M132.69,745.13s2.76,11.87,4.1,13.41l2.32-10.24-1.87-5.95Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M155.3,646.64s3.72,6.44,6.39,6.59c0,0-3.47.36-5.54-1Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M207.28,690.39l-6.4-72.83-9.28,5.67s8.8,64.54,3.09,73.93A34.89,34.89,0,0,0,207.28,690.39Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M239.2,501.26h0a5.31,5.31,0,0,0-7.43-.82l-3,2.38a5.29,5.29,0,0,0-.83,7.43h0a5.31,5.31,0,0,0,7.43.83l3-2.38A5.3,5.3,0,0,0,239.2,501.26Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M200.88,617.56s-1.28-12.77.37-16.53,3.87-25.57,3.87-25.57l-3-1.23c-4.28,7.8-10.2,10.69-10.53,51.36C191.57,625.59,199.93,623.55,200.88,617.56Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M189.55,565.4l22.89-27.22a13.69,13.69,0,0,0,2.3-3.9l10.88-28.52,10.46,4.76-9,32.65a13.69,13.69,0,0,1-1.57,3.59l-21.21,34-12,2.33Z",
    transform: "translate(0 -4.31)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M706.78,720.44c-11.74-6.5-31.9-7-45-1.19a26.84,26.84,0,0,0-5.66,3.33c-8.29-2.74-19.56-2.47-27.33,1-9.22,4.11-10,11.15-1.74,15.72,7.93,4.39,21.3,4.89,30.52,1.28.54.36,1.11.71,1.73,1,11.74,6.51,31.9,7,45,1.19S718.53,727,706.78,720.44Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M631.38,728.63l12.55-14.91c2-1.05,5.59-1.48,8.56-1a2.4,2.4,0,0,1,2.14,2.43l.35,2.47c.45,4.14,1,5.5-1.6,6.88l-15.25,8.21C635,735.2,626.11,734.06,631.38,728.63Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M644.45,715.22s-7.17,8.88-6.23,9.5c3.89,2.56,12.89-5.29,12.89-5.29S646.12,714.75,644.45,715.22Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M651.31,718.59c-1.95,3.71-7.52,1.35-7.84-2.55,0-21.81-4.63-38.94-4.6-59.34,0-22.89,1.72-23.29,1.82-58.39L662,601.68c-3.91,25.24-5.55,57.13-5.55,57.13C662.08,683.27,655.39,688.51,651.31,718.59Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M689.7,738l-.14-19.49c.8-2.06,3.3-4.75,5.88-6.31a2.41,2.41,0,0,1,3.2.46l1.87,1.65c3,2.86,4.31,3.56,3.25,6.28l-6.27,16.14C696.72,740.69,689.21,745.6,689.7,738Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M690.93,719.35s.32,11.42,1.43,11.28c4.62-.58,6.54-11.2,6.54-11.2S691.9,717.92,690.93,719.35Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M698.9,719.43c-.9,4.09-6.9,3.3-8.24-.37-5.75-21-14.8-36.32-20.19-56-6-22.09-4.53-22.91-13.75-56.78l21.42-2.41c2.93,25.38,9.82,56.55,9.82,56.55C699.9,682.52,694.84,689.35,698.9,719.43Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M641.53,569.53s-4.52-1.75-2.38,78.81c0,0,5.1,4.67,19.14,8.32,13.23,3.45,21.83-12.14,32.54-8.44,0,0-6.62-15.4-5.73-22.61s5.31-49.36-6.55-50.73S641.53,569.53,641.53,569.53Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M690.83,648.24s-6.62-15.4-5.73-22.62,5.31-49.35-6.55-50.73c-2.7-.31-6.1-.76-9.73-1.27.82,7,2.48,18.52,5.74,37.32,4.36,25.07-3.86,38.9-11.94,46.22C673.5,656.82,681.34,645,690.83,648.24Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M657.77,480.49l16.46,14.12A38.86,38.86,0,0,0,688,508c8.9,4.84,11.5,10.5,10.87,25.31s21,14.65,12.71,29.12S672.82,574.51,664.7,564s-20.79-42.74-16.62-52.16S657.77,480.49,657.77,480.49Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M637.15,531c6.88,6.49,11.42-1.15,11.42-1.15l2.14-14c-3.19-5.29-15.4-11.9-25.48-18.2a11.61,11.61,0,0,1-3.09-8.34l1.12-25.4-5.42-.84-8.24,24.84c-3.59,9.29,5.71,19.56,7.12,21.42C616.72,509.31,629,523.32,637.15,531Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M617.75,451.59h0c-2.92.48-5,2.77-4.59,5.1l3.65,8.29c.39,2.33.34.66,3.27.18h0c2.92-.48,3.66,1.68,3.89-2.93l-1.28-6.56a7.6,7.6,0,0,0-.88-2.44C621,451.82,620.05,451.21,617.75,451.59Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M641.81,531.22s-.52-18.89,9.83-18.94c1.45,0,3.82-1.42,5.48-1.39,8.65.14,7.43.23,13.77,2.44,2.39.83,4.1,7.61,3.81,10.17l4.07,7.54Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M648.08,511.86c1.68-.29,3.89-.78,3.69.21-.86,4.34-.42,7.28,1.1,8.51,9.19,7.41,13.42-3.33,14.27-7.13.14-.64,1-1.6,1.61-1.23l3.45,1.26c18.59,4.93,14.31,10.11,10.12,20.12,0,0-4.91,17.53-4.86,24.66,0,6.16,5.91,15.47,7,17.4,1.45,2.51-6.22,18.81-30,17-18.77-1.46-16.93-9.24-16.91-19.44,0-6.41,3.29-23.65,3-28.73s-4.31-8.73-1.91-17a108.7,108.7,0,0,1,6.88-16.85Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M659.37,516.59l-.61.09a3.48,3.48,0,0,1-4.07-3.09l-1.11-11.36A4,4,0,0,1,657,498l.61-.09c2-.31,5.12.47,5.32,2.48l1.67,12C664.75,514.44,661.42,516.28,659.37,516.59Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M654.11,508.69a10.93,10.93,0,0,0,8.38-4.53s-3.53,7.11-8,7.7Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M645.18,491.19s-3,11.88,3.7,14.95,10.17-21.39,10.17-21.39Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M666.09,486c-1.55-3.18-4.22-4-6.88-2.51-2.39-1.3-5.49-.06-8,3.64-3.49,5.15-5,13.72-2.73,18.36a5.23,5.23,0,0,0,4.47,2.83,12.76,12.76,0,0,0,4.83-.39c5.69-1.54,5.72-.71,8-4.14C669.32,498.61,668.34,490.61,666.09,486Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M662.41,487.58c1.67,5.47,1.18,17.72,1.37,19.37,0,0,11.17.34,10.45-12.34-.89-15.78-10.29-8.4-10.29-8.4Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M666.08,490c-5.93-2.88-10.83-5.17-20.73,2.17-.63-1.38,1.48-5.75,3.54-7.08,4.3-2.78,6.48-4.29,11-5L661,480c6.58-.32,9.89,2.4,10.9,8.78.09.56,1.06,3.15,1.06,3.62l-2.05-.83C671,495.31,669.86,489.67,666.08,490Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M652.24,504.56h0c-1.21-.44-2.2-2.37-2.2-4.31l4.41,1.6C654.45,503.79,653.46,505,652.24,504.56Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M675,453.75h0c2.91-.52,5.63.95,6,3.27l-.66,9c.4,2.33-.11.73-3,1.26h0c-2.91.53-2.89,2.81-4.65-1.46l-1-6.61a7.57,7.57,0,0,1,0-2.6C672.05,455.06,672.73,454.17,675,453.75Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M683.71,535.74c-3.94,9.19-9.9,11.12-9.9,11.12l.84-26.5,8.73-20.72a11.61,11.61,0,0,0,.13-8.89L674,467.19l4.83-2.61,16.08,20.65c6.49,7.55,1.16,20.35.46,22.57C695.32,507.8,688.15,525.4,683.71,535.74Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 664.93,
    cy: 496.72,
    r: 3.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M684.66,575.86c-1.12-1.94-7-11.25-7-17.41,0-4,1.53-11.4,2.89-17-5.32,11.66-5.26,15.7-12.23,17.35,12.07,16.71,4.65,30-6,34C680.1,591.06,686,578.07,684.66,575.86Z",
    transform: "translate(0 -4.31)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M110.27,406.44h0a3.65,3.65,0,0,1,2.57,4.49l-1.74,6.94a3.69,3.69,0,0,1-4.38,2.77h0a3.65,3.65,0,0,1-2.56-4.49l1.73-6.94A3.69,3.69,0,0,1,110.27,406.44Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1.22,434.28h0a3.64,3.64,0,0,1,5.13.52L11,440.26a3.69,3.69,0,0,1-.3,5.17h0a3.65,3.65,0,0,1-5.14-.53L.91,439.45A3.69,3.69,0,0,1,1.22,434.28Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M80.76,472.31s18.55-14.66,19.7-23.3c1.29-9.64,3-30.28,3-30.28l11.11-1.21s4.29,35.29-.52,43.79-17.64,34.33-17.64,34.33Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M114.59,417.52l-1.63.24s3.45,27.54-2.79,42.57c-2.63,6.33-12.93,22.35-17,30.47l3.25,4.84s12.83-25.83,17.64-34.33S114.59,417.52,114.59,417.52Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.67,687.75c9.11-4.92,24.37-5.29,34.6-.92.93-2.1,2.92-4.1,6-5.77,9.39-5.07,25.29-5.31,35.51-.52s10.91,12.77,1.52,17.84c-9.12,4.92-24.37,5.28-34.61.92-.92,2.09-2.92,4.09-6,5.77-9.38,5.07-25.28,5.3-35.51.52S23.28,692.82,32.67,687.75Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M64.26,471.77s-7.46,2.07-7.45,5.9a41.67,41.67,0,0,0,.74,7.36l25.08-5.28L80,469.4Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M103.58,681.87,89.7,672.36a12.42,12.42,0,0,0-7.43,0c-1.29.38-1.53-.58-1.42.62l-1.2,5.11c-1.17,3.41,1.54,5.47,5.44,6.65l13.27,3.79c2.75.89,6.62.39,8.61-1.11l.56-.42C109.51,685.51,106.52,683.46,103.58,681.87Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M80.92,673.93c.23,4,9.85,3.42,9.63-.54l-.73-12.87-9.63.55Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M79.37,669c4,3,8.08,2.88,12.09-.32,0,0,6.76-79.55,4.51-120.41l-30.35-9.48C69.43,563.89,77.69,605,77.69,605,68.89,625.64,76.83,651.16,79.37,669Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M65.62,538.83l8.51,2.66c2.34,14.84,6,34.25,8.56,47.69a73.3,73.3,0,0,1,0,26.5c-3.19,18.26,2.67,38.46,4.78,53.36a12.62,12.62,0,0,0,1.8,1.12c-3.29,1.7-6.58,1.34-9.89-1.12-2.26-15.89-8.78-37.82-4-57a40.44,40.44,0,0,0,.29-17.45C72.94,580.75,68.23,556,65.62,538.83Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M46.64,683.85c-.41,3.94,9.18,4.93,9.59,1L57.55,672,48,671Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M45.92,679c4.12,3.37,8.14,4,12,1.37,0,0,3.45-26.42,8.86-54.57,4.18-21.78,10.39-43.65,11.81-61L50.41,548.42c.25,15.41-.9,49.33-1.43,63.88a24.41,24.41,0,0,1-2.47,9.77C40,635.4,45.92,679,45.92,679Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M98.38,550.21a480.65,480.65,0,0,1-.25-51.94c-1.67-24.2-11.43-32.52-26.29-25.91l-6.18,2.11C48,485.65,38.57,485.8,43.2,505l4.36,46.15C49.08,573.16,101.34,576,98.38,550.21Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M58.27,478.75s-.49,6.69,9.58,11.48c5.19,2.47,8,7.1,9.57,11,.9,2.28,2.18,1,2.24-1.47.17-6.47.25-8.35,1.22-13.2,1.56-7.85-2.64-19-3.07-19S58.27,478.75,58.27,478.75Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M71.12,472.74s9.46,2.15,8.08,11L79.87,494s6.15-12.24,1.89-22.85S71.12,472.74,71.12,472.74Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M75,472.84s-1.46,2.81-2.48,3.44-16.36-4.69-16-17c.27-7.8,15.08-7.1,15.08-7.1Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M69.64,484.56l.74.05a4.56,4.56,0,0,0,4.88-4.22l1-14.13a4.58,4.58,0,0,0-4.22-4.88l-.74-.06a4.58,4.58,0,0,0-4.89,4.23l-3,13.43C63.27,481.48,67.13,484.38,69.64,484.56Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M75.74,473.89a12.51,12.51,0,0,1-10.4-4.65s4.59,8.38,10.11,8.6Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M62.42,472.31s-5.81,8.51,6.48,13.81c0,0,4.95,4.36,5.46,9.54,0,0-4.21-2.81-6.63-4.32S47.35,480.6,62.42,472.31Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.56,469.21c3.44,5.59,8.43,6,11.16,1s2.13-13.65-1.31-19.24-8.43-6-11.16-1S68.12,463.62,71.56,469.21Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64.61,469.07c3.44,5.59,14.59,7.41,17.31,2.37S80,456.35,76.6,450.76s-8.44-6-11.16-1S61.17,463.48,64.61,469.07Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M68.93,453.19s3.51,11.66-5.44,16c0,0-11.75-4.22-6-17.09C62.54,440.78,75,446.47,75,446.47Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M84.13,458.73a11.52,11.52,0,0,0-8.78-5.91L79.72,449S84.92,449.25,84.13,458.73Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M65.26,461.08c1.57-3.16,6-3.93,12.69-2.8a5.71,5.71,0,0,0,3-.24c4.5-1.81,4.16-7.74,4.16-7.74.31-4.05-2.57-5.34-6.63-5.65L68,443.85c-6-.49-10.68,5.2-11,9.26l-.15.69C56.51,457.86,61.2,460.77,65.26,461.08Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M62.36,469.05a2.89,2.89,0,1,0,1-4A2.89,2.89,0,0,0,62.36,469.05Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M56.28,684.3l-.69,8.15a48.53,48.53,0,0,1-1.43,6.92,5.88,5.88,0,0,1-5,3.68c-2.5.17-7.51-4.25-5.72-9.73,1.56-4.78,3.24-9.81,3.24-9.81C50.19,685.12,53.46,685.69,56.28,684.3Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M78.77,471.12h0c1.26-.5,2.28-2.52,2.28-4.52l-4.57,1.79C76.48,470.39,77.51,471.61,78.77,471.12Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M4.67,446.35,13,478.71a37.15,37.15,0,0,0,9.69,17l21.71,21.72L52.09,485l-21.51-8.7L15,441.57Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M27.86,489.51a37.13,37.13,0,0,1-9.69-17L7.36,445.05,4.67,446.3,13,478.65a37.09,37.09,0,0,0,9.69,17l21.71,21.73L42,503.68Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M42,503.68l5.53,47.51c.89,12.81,19,19.11,33.41,17C63.94,559.68,51,534.89,42,503.68Z",
    transform: "translate(0 -4.31)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 291.51,
    y: 533.7,
    width: 234.99,
    height: 68.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 346.71,
    y: 549.58,
    width: 124.59,
    height: 36.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M523.84,514.64c-14.18,8.34-45,16.51-111,11.85-42.62-3-26.68-14.61-26.68-34.89s34.64-36.71,77.38-36.71c21.37,0,40.71,4.11,54.71,10.75Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M454,444c-13.33-4.95-29.41-7.85-46.71-7.85a138,138,0,0,0-43.11,6.59l-40.39,5.55V482c0,25.33,37.39,45.86,83.5,45.86,44.2,0,80.35-18.86,83.28-42.72l.2-36.47Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 407.31,
    cy: 444.01,
    rx: 83.5,
    ry: 42.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 374.26,
    y: 328.46,
    width: 66.11,
    height: 134.09,
    rx: 28.28,
    transform: "translate(814.62 786.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M234.77,181.77l50.93-2,1.78,30.52-.28,0-29.62-4.56c-8.52-1.34-13.34,4.17-10.45,12,8.32,22.62,28.21,64.37,62.78,68.45l4.07,34.6c-54-6.38-87.42-75.65-100.42-111C209.05,197.45,221.45,179.66,234.77,181.77Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M227.11,198.49l48.1-.38,14.73-.46c12.06-7.62-1.54,21.66-1.54,21.66l-40.8,4.05C239.86,222,235.41,227.83,238,236c7.32,23.64,37,75.35,75.13,74.73l12.28,25.07C255.19,334.37,223.46,255.26,212,218.3,208.06,205.47,215,196.39,227.11,198.49Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M565.23,181.77l-50.93-2-1.78,30.52.28,0,29.62-4.56c8.52-1.34,13.34,4.17,10.45,12-8.32,22.62-28.21,64.37-62.78,68.45L486,320.74c54-6.38,87.42-75.65,100.42-111C591,197.45,578.55,179.66,565.23,181.77Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M572.89,198.49l-48.1-.38-14.73-.46C498,190,511.6,219.31,511.6,219.31l40.8,4.05c7.74-1.35,12.19,4.47,9.65,12.67-7.31,23.64-37,75.35-75.13,74.73l-12.28,25.07c70.17-1.46,101.9-80.57,113.33-117.53C591.94,205.47,585,196.39,572.89,198.49Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(285.58 161.69)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(285.58 161.69)",
    xlinkHref: "#image-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M313,262.1,295.83,155.93l-14.62,12.8,11.9,93.37c6.58,50,36.61,91.63,77,106.77l19.84,5.33C349.55,359.06,319.53,312.08,313,262.1Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 406.54,
    cy: 161.82,
    rx: 125.32,
    ry: 58.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 406.54,
    cy: 161.82,
    rx: 93.4,
    ry: 42.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M406.54,151.73c40.82,0,75.52,11.8,88.23,28.24,3.34-4.34,5.17-9,5.17-13.84,0-23.24-41.82-42.08-93.4-42.08s-93.4,18.84-93.4,42.08c0,4.85,1.82,9.5,5.17,13.84C331,163.53,365.72,151.73,406.54,151.73Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 407.31,
    cy: 283.53,
    rx: 48.91,
    ry: 48.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M411.91,259.43l7.24,13.07A5.14,5.14,0,0,0,423,275l16.2,2.1c4.2.54,5.88,5.14,2.84,7.78l-11.73,10.18a4.27,4.27,0,0,0-1.47,4l2.77,14.38c.72,3.72-3.68,6.56-7.43,4.8l-14.49-6.78a5.68,5.68,0,0,0-4.77,0l-14.49,6.78c-3.76,1.76-8.15-1.08-7.44-4.8l2.77-14.38a4.22,4.22,0,0,0-1.47-4l-11.73-10.18c-3-2.64-1.36-7.24,2.84-7.78l16.21-2.1a5.12,5.12,0,0,0,3.85-2.5l7.25-13.07A5.42,5.42,0,0,1,411.91,259.43Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 625.19,
    cy: 309.64,
    r: 9.17,
    transform: "translate(180.2 842.65) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 570.46,
    cy: 63.27,
    r: 9.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 181.2,
    cy: 285.59,
    r: 9.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 195.32,
    cy: 49.24,
    r: 9.17,
    transform: "translate(22.39 148.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 753.81,
    cy: 474.31,
    r: 9.17,
    transform: "translate(-114.6 667.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 390.56,
    cy: 13.48,
    r: 9.17,
    transform: "translate(24.57 146.18) rotate(-22.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.03,
    cy: 179.97,
    r: 9.17,
    transform: "translate(-67.73 13.05) rotate(-22.37)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M348.1,475l20.14,220.64c.2,2.15,1.39,3.93,2.66,3.94h.36c1.26,0,2.14-1.74,1.94-3.9l-3.15-34.51,39.62.34L412.82,696c.19,2.16,1.39,3.93,2.65,3.94h.36c1.27,0,2.14-1.74,1.95-3.9l-3.35-36.71h0l-.26-2.86h0L411,621.39h0l-.13-1.46-3.58-39.19v-.14h0L404,544.76l-.19-2.1h0l-3.21-35.09h0l-.26-2.85h0l-2.67-29.3c-.2-2.16-1.39-3.93-2.66-3.94h-.36c-1.26,0-2.14,1.75-1.94,3.9l2.47,27.1-39.61-.34L353.06,475c-.19-2.15-1.39-3.92-2.66-3.93h-.35C348.78,471.08,347.91,472.84,348.1,475Zm47.72,34.75,2.8,30.67L359,540.07l-2.8-30.67Zm-36.16,37.6,39.62.34,2.8,30.67L362.46,578Zm3.47,37.94,39.61.34,2.8,30.67L365.92,616Zm6.26,68.61-2.8-30.67,39.61.34,2.8,30.67Z",
    transform: "translate(0 -4.31)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 501.28,
    cy: 749.81,
    rx: 46.24,
    ry: 31.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M514.77,734.27c-8.47-6.43-20.75-10.48-34.43-10.48-12.9,0-24.56,3.6-32.95,9.41L434.16,733l-.05,22.29c0,17.38,20.7,31.48,46.23,31.48,24.76,0,45-13.25,46.18-29.9l.06,0V734.45Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 480.34,
    cy: 730.14,
    rx: 46.24,
    ry: 31.48
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-37",
    points: "461.31 719.88 480.34 741.2 503.18 714.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 377.37,
    cy: 749.81,
    rx: 46.24,
    ry: 31.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M390.86,734.27c-8.46-6.43-20.75-10.48-34.42-10.48-12.91,0-24.57,3.6-33,9.41L310.25,733l-.05,22.29c0,17.38,20.7,31.48,46.24,31.48,24.75,0,45-13.25,46.17-29.9l.06,0V734.45Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 356.44,
    cy: 730.14,
    rx: 46.24,
    ry: 31.48
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M357.59,715.06l4.66,7.55a3.31,3.31,0,0,0,2.47,1.44l10.41,1.21c2.7.31,3.77,3,1.82,4.49l-7.53,5.87a2.33,2.33,0,0,0-.94,2.33l1.77,8.3c.46,2.15-2.36,3.79-4.77,2.77l-9.31-3.91a4,4,0,0,0-3.06,0L343.8,749c-2.41,1-5.23-.62-4.77-2.77l1.78-8.3a2.33,2.33,0,0,0-.95-2.33l-7.53-5.87c-1.95-1.52-.87-4.18,1.83-4.49l10.4-1.21a3.35,3.35,0,0,0,2.48-1.44l4.65-7.55A3.71,3.71,0,0,1,357.59,715.06Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M347,469.41l1.41,226.11c0,2.21,1.06,4,2.33,4h.36c1.26,0,2.28-1.79,2.27-4l-.22-35.37,39.59.35.22,35.36c0,2.21,1.06,4,2.32,4h.36c1.27,0,2.29-1.79,2.28-4l-.24-37.63h0l0-2.93h0l-.22-35.95h0v-1.51l-.25-40.15v-.15h0l-.23-36.73,0-2.15h0l-.22-36h0l0-2.92h0l-.19-30c0-2.2-1-4-2.32-4h-.36c-1.26,0-2.29,1.79-2.27,4l.17,27.77-39.59-.35-.17-27.77c0-2.21-1.06-4-2.32-4h-.36C348,465.4,347,467.2,347,469.41ZM391.73,505l.19,31.43-39.58-.35-.2-31.43Zm-39.35,38.54,39.59.34.2,31.43L352.58,575Zm.25,38.88,39.58.34.2,31.43-39.59-.34Zm.43,70.31-.19-31.43,39.59.35.19,31.43Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M169.69,530.58S161.42,520.3,154,533s-3.28,27.71-13.82,35c0,0,18.43.24,20.49-11.44s1-21.55,7.57-21.86S169.69,530.58,169.69,530.58Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M432.61,193.32c1.46,14.49,1.17,68.78,1.17,68.78a9.25,9.25,0,0,0,1.22.54l-.05,5.11-11.05,8.33c-2.51,1.51-5,3.42-3.25,4.65l.51.35a9.27,9.27,0,0,0,7.56.63l11.43-3.83c3.37-1.19,5.65-3.09,4.49-6l-1.25-4.41a1.6,1.6,0,0,0,0-.41l0-3.24.55,0c6.58-.45,14.3-50.61,10.5-59.38l11-6.83c-2.06,3.83-2.92,7.4-1.79,10.29,5.31,13.55,21.43,69.52,21.43,69.52a10,10,0,0,0,2.14.12l.95,3.46L480,292c-2,2.14-3.88,4.69-1.82,5.37l.59.2a9.28,9.28,0,0,0,7.43-1.5l9.92-6.87c2.9-2.08,4.56-4.54,2.63-7l-2.43-3.89a1.84,1.84,0,0,0-.12-.39l-.65-2.33c5.15-5-3.26-53.7-9.1-60.89l23.18-21.18c4.72-7.84,3.72-19.5,3.72-19.5L436,184.8C433.68,187.77,432.34,190.67,432.61,193.32Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M450.63,26.77h0a3.43,3.43,0,0,0-2.5,4.16l1.49,6.55a3.46,3.46,0,0,0,4.05,2.69h0a3.43,3.43,0,0,0,2.5-4.16l-1.49-6.55A3.46,3.46,0,0,0,450.63,26.77Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M477,89.2s-17.11-14.14-18-22.27c-1-9.08-2.22-28.49-2.22-28.49l-10.4-1.36s-4.74,33-.4,41.11,15.85,32.58,15.85,32.58Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M446.35,37.08l1.53.26s-3.8,25.77,1.75,40c2.34,6,11.67,21.25,15.32,28.94l-3.15,4.48S450.29,86.26,446,78.19,446.35,37.08,446.35,37.08Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M512.13,151.58s7,26.8-4.72,36.21-35.51,10.64-35.51,10.64l-8.41-32.29,2.45-23.66Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M416.22,273.84,428,265a10.87,10.87,0,0,1,6.5-.27c1.13.28,1.3-.57,1.25.48L437,269.6c1.16,2.94-1.12,4.85-4.49,6L421,279.47a9.31,9.31,0,0,1-7.56-.63l-.51-.35C411.18,277.25,413.72,275.34,416.22,273.84Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M435.69,266c0,3.47-8.47,3.37-8.43-.1l.13-11.26,8.43.1Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M472.27,289.78,481.08,278a10.93,10.93,0,0,1,6.17-2.07c1.17-.05,1.09-.91,1.34.12l2.43,3.89c1.93,2.5.27,5-2.63,7l-9.92,6.87a9.28,9.28,0,0,1-7.43,1.5l-.59-.19C468.39,294.46,470.29,291.92,472.27,289.78Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M488.8,276.84c.93,3.34-7.2,5.59-8.12,2.25l-3-10.85,8.13-2.26Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M469.73,154.77s-46.26,21.82-44.8,36.31,1.17,68.77,1.17,68.77,3.61,2.11,10.19,1.67,14.3-50.61,10.5-59.39l39.35-24.32Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M489.35,163.49S450.73,192,456,205.59s21.43,69.53,21.43,69.53,3.6.76,9.82-1.45-2.54-53.81-8.57-61.24l28.55-26.08Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M459.22,154.76c.46-13,4.17-26.08,2.81-42.32.8-22.41,9.56-30.4,23.49-24.75l5.77,1.75C508,99.22,516.67,99.07,513,117l-2.6,42.77C509.67,180.1,457.29,178.64,459.22,154.76Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M513.6,116.47l3.92,42.2c-.42,11.86-23.28,15.77-36.64,14.29C496.35,164.54,506.27,145.59,513.6,116.47Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M498.26,93.17s.65,6.17-8.5,10.9c-4.72,2.44-11.11,1.47-12.15-3-1.69-7.21,1.85-17.59,2.24-17.65S498.26,93.17,498.26,93.17Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M483.75,88.77s1.92,2.21,3,2.55,13.68-7.78,10.62-18.75c-1.94-6.95-15.09-3.1-15.09-3.1Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M487.93,98.89l-.68.07a4.22,4.22,0,0,1-4.64-3.75l-1.39-13A4.24,4.24,0,0,1,485,77.54l.68-.07a4.24,4.24,0,0,1,4.65,3.75l3.17,12.32C493.72,95.85,490.24,98.64,487.93,98.89Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M482,89.22a11.55,11.55,0,0,0,9.46-4.62s-4,7.88-9.07,8.26Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 479.6,
    cy: 77.65,
    rx: 7.19,
    ry: 12.68,
    transform: "translate(-5.19 41.3) rotate(-5.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M492.22,83.13c-1.87,5.77-11.49,9.84-15,5.91s-1.6-14,.27-19.74,6.26-7.27,9.8-3.34S494.09,77.36,492.22,83.13Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M484.88,69.81s-.61,11.24,8.38,13.21c0,0,9.64-6.35,1.67-16.66-7-9.09-16.94-1.27-16.94-1.27Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M472.43,78.1a10.68,10.68,0,0,1,6.6-7.23l-4.75-2.46S469.65,69.76,472.43,78.1Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M489.9,76.09c-2.1-2.5-6.24-2.22-12,.25a5.17,5.17,0,0,1-2.79.45c-4.44-.64-5.42-6-5.42-6-1.16-3.57,1.14-5.36,4.72-6.52l9.32-3c5.27-1.75,10.73,2.35,11.89,5.93l.28.58C497.06,71.29,493.47,74.93,489.9,76.09Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M494.24,82.62a2.68,2.68,0,1,1-1.72-3.37A2.67,2.67,0,0,1,494.24,82.62Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M480,88.06h0c-1.24-.17-2.6-1.76-3-3.56l4.5.61C481.85,86.9,481.19,88.23,480,88.06Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M537.18,42.6h0A3.43,3.43,0,0,0,532.53,44l-3.3,5.84a3.47,3.47,0,0,0,1.19,4.72h0a3.43,3.43,0,0,0,4.65-1.39l3.3-5.85A3.45,3.45,0,0,0,537.18,42.6Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M536.12,54.34l-1.94,31.3A34.81,34.81,0,0,1,528.24,103l-16.19,23.86L499.22,98.37l18.3-11.82,8.26-34.81Z",
    transform: "translate(0 -4.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M522.35,98.22a34.84,34.84,0,0,0,5.94-17.39l5.12-27.22,2.7.68-1.94,31.3A34.84,34.84,0,0,1,528.23,103L512,126.83l-.25-13Z",
    transform: "translate(0 -4.31)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVictory);
export default __webpack_public_path__ + "static/media/Victory.7f709a077d65678d6c1c796bb35d74ba.svg";
export { ForwardRef as ReactComponent };